export default __webpack_public_path__ + "c8e6313e230d455acbfa08c36713365e.js";